import { render, staticRenderFns } from "./TopupPaymentPage.vue?vue&type=template&id=33f6c27e&scoped=true"
import script from "./TopupPaymentPage.vue?vue&type=script&lang=js"
export * from "./TopupPaymentPage.vue?vue&type=script&lang=js"
import style0 from "./TopupPaymentPage.vue?vue&type=style&index=0&id=33f6c27e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f6c27e",
  null
  
)

export default component.exports